export const getStyled = (theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 4,
    backgroundColor: theme.custom.colors.defaultBackground,
  },

  multFieldLine: {
    marginTop: 12,
    display: 'flex',
    '& > *:not(:last-child)': {
      marginRight: theme.spacing(1),
    },
  },

  btnWrapper: {
    position: 'relative',
  },
  importMessage: {
    marginTop: 12,
    marginBottom: 12,
    paddingBottom: 20,
    paddingTop: 3,
    padding: 12,
    border: 'solid grey 2px',
    borderRadius: 4,
    display: 'flex',
    '& > *:not(:last-child)': {
      marginRight: theme.spacing(1),
    },
  },

  tab: {
    color: `${theme.custom.colors.text} !important`,
    backgroundColor: theme.custom.colors.defaultBackground,

    '& .MuiTab-root': {
      color: '#999999',
    },
    '& .Mui-selected': {
      color: `${theme.custom.colors.text} !important`,
    },
    '& .MuiTabs-indicator': {
      backgroundColor: `${theme.custom.colors.text} !important`,
    },
  },

  buttonProgress: {
    color: theme.custom.colors.confirmationButton,
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },

  tokenRefresh: {
    minWidth: 'auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
});
